import { defineMessages } from "react-intl";

import {
	fyrmsSignedMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/patientStatementOfConsentFyrms";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientStatementOfConsentFyrms: {
		id: "ktx.form.patient_statement_of_consent_fyrms",
		defaultMessage: "Páciens beleegyező nyilatkozat (TIMM)"
	},
	fyrmsSigned: {
		id: "ktx.form.patient_statement_of_consent_fyrms.signed",
		defaultMessage:
			"Kérjük az űrlaphoz töltse fel mellékletként az aláírt nyilatkozatot beszkennelt vagy lefotózott formában és a nyilatkozatot papír alapon őrizze meg a beküldő intézmény."
	}
});

const fields: { [key: string]: FieldData } = {
	fyrmsSigned: {
		type: "field",
		path: ["fyrmsSigned"],
		label: messages.fyrmsSigned,
		errorMessages: genericErrorMessages,
		input: {
			type: "radio-group",
			props: { labels: fyrmsSignedMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.fyrmsSigned }] }]
};

export const node: LeafNode = {
	id: "ktx_patientStatementOfConsentFyrms",
	value: {
		schemaId: "patientStatementOfConsentFyrms",
		title: messages.patientStatementOfConsentFyrms,
		validator,
		fieldset
	}
};
